import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import axios from 'axios';
import { GET_SIGNED_URL } from "config";


interface VideoPlayerProps {
  type: string;
  contentUrl: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ type, contentUrl }) => {
  const [videoUrl, setVideoUrl] = useState<string>();

  useEffect(() => {
    const getVideoUrl = async () => {
      try {
        console.log("getVideoURL start ", contentUrl)
        const response = await axios.post(GET_SIGNED_URL, { contentUrl })
        console.log("url", response.data.url)
        setVideoUrl(response.data.url);
      } catch (error) {
        console.error('Error fetching video URL:', error);
      }
    };

    getVideoUrl();
  }, [contentUrl]);

  return (
    <Box>
      {videoUrl ? (
        <video width="320" height="240" src={videoUrl} controls>
          Your browser does not support the video tag.
        </video>
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default VideoPlayer;
